import { consumerRoot } from 'src/config'
import Model from 'src/models/model'

export function deletePrefix (str, prefix) {
  if (prefix && _.startsWith(str, prefix)) {
    return str.slice(prefix.length)
  }
  return str
}

export function deleteSuffix (str, suffix) {
  if (suffix && _.endsWith(str, suffix)) {
    return str.slice(0, -suffix.length)
  }
  return str
}

/**
 * Returns the path prepended by the `consumerRoot` unless it is
 * already present. Always returns a path starting with '/' and
 * never ending with '/'.
 */
export function prependWithConsumerRoot (path) {
  if (consumerRoot === '/') {
    path = _.trim(path, '/')
    return `/${path}`
  }

  path = deletePrefix(path, consumerRoot)
  path = _.trim(path, '/')
  // Assumes consumerRoot ends with '/'
  return `${consumerRoot}${path}`
}

export function createConsumerSitePathRegexp (siteRootPath) {
  siteRootPath = _.trim(siteRootPath, '/')
  const consumerSiteRootPath = prependWithConsumerRoot(siteRootPath)
  let pattern
  if (consumerSiteRootPath === '/') {
    pattern = '^/(.*)?$'
  } else {
    pattern = `^${_.escapeRegExp(consumerSiteRootPath)}(/.*)?/?$`
  }
  return new RegExp(pattern)
}

// Remove any wrong, non-root path prefix. Also remove non-'/'
// consumerRoot as that will be added back later if required.
export function removeMismatchedSiteRootPath (path) {
  const currentSite = Model.configuration.currentSite
  const sharedHostnameSiteIdsByPath = Model.configuration.currentSite.sharedHostnameSiteIdsByPath
  let unprefixedPath = path

  _.find(sharedHostnameSiteIdsByPath, (siteId, sitePath) => {
    // All paths start with '/' so no need to check for it.
    // We want the currentSite's path, so skip currentSite.
    if (sitePath !== '/' && siteId !== currentSite.id) {
      const consumerSiteRoot = prependWithConsumerRoot(sitePath)
      if (path === consumerSiteRoot) {
        unprefixedPath = '/'
        return true
      } else if (_.startsWith(path, `${consumerSiteRoot}/`)) {
        unprefixedPath = deletePrefix(path, consumerSiteRoot)
        return true
      }
    }

    return false
  })

  return unprefixedPath
}
